// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__uZ5Pt","row":"Footer_row__FZBj2"};